import { api } from '@marketplace-web/core-api/core-api-client-util'

import { createPaymentsAccountArgsToParams } from '../transformers/payments-account'

import { CreatePaymentsAccountArgs, PaymentsAccountResp } from '../types/payments-account'

export const startOnboarding = (userId: number) =>
  api.put(`/users/${userId}/payments_account/start_onboarding`)

export const createPaymentsAccount = (account: CreatePaymentsAccountArgs) =>
  api.post<PaymentsAccountResp>(
    `/users/${account.userId}/payments_account`,
    createPaymentsAccountArgsToParams(account),
  )

export const getPaymentsAccount = (userId: number) =>
  api.get<PaymentsAccountResp>(`/users/${userId}/payments_account`)
